import React, { useState } from 'react';
const faqs = [{
  q: 'Jak otrzymam materiały?',
  a: 'Po zakupie otrzymasz natychmiastowy dostęp do plików PDF.'
}, {
  q: 'Czy materiały nadają się do pracy z młodzieżą?',
  a: 'Tak, pakiet został przygotowany z myślą o trenerach pracujących z różnymi grupami.'
}, {
  q: 'Czy mogę wydrukować materiały?',
  a: 'Tak, pliki można zarówno przeglądać cyfrowo, jak i drukować.'
}, {
  q: 'Czy pakiet nadaje się także dla mniej doświadczonych trenerów?',
  a: 'Tak, materiały są uporządkowane i praktyczne, dzięki czemu pomagają również osobom, które chcą lepiej poukładać swoją pracę.'
}, {
  q: 'Czy mogę używać materiałów na telefonie i tablecie?',
  a: 'Tak, pliki PDF można otwierać na różnych urządzeniach.'
}, {
  q: 'Jak działa 7-dniowa gwarancja?',
  a: 'Masz 7 dni na sprawdzenie materiałów. Jeśli pakiet nie spełni Twoich oczekiwań, możesz poprosić o zwrot.'
}, {
  q: 'W jakim formacie otrzymam materiały?',
  a: 'W formacie PDF.'
}, {
  q: 'Czy otrzymam przyszłe aktualizacje?',
  a: 'To zależy od oferty, ale podstawowy pakiet zawiera wszystkie materiały opisane na stronie.'
}, {
  q: 'Jakie metody płatności są dostępne?',
  a: 'Zależnie od platformy płatniczej dostępnej na stronie zakupu.'
}, {
  q: 'Czy mogę liczyć na pomoc w razie pytań?',
  a: 'Tak, informacje organizacyjne będą dostępne po zakupie.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-87">
          Najczęściej zadawane pytania
        </h2>

        <div className="space-y-4 mb-16" data-id="element-88">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(37,99,235,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-89">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-90">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-91">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-92">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-93">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-94">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-95">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(22,193,114,0.15) 0%, transparent 70%)'
        }} data-id="element-96"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-4 w-full sm:w-auto max-w-2xl text-gray-900 shadow-[0_0_30px_rgba(22,193,114,0.3)] border border-white/20" data-id="element-97">
            🚀 TAK! CHCĘ MEGAPACK KOMPLETNY
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-98">
            <span data-id="element-99">⚡ Natychmiastowy dostęp</span>
            <span data-id="element-100">•</span>
            <span data-id="element-101">🛡️ 7 dni gwarancji</span>
            <span data-id="element-102">•</span>
            <span data-id="element-103">💳 79 zł płatność jednorazowa</span>
          </p>
        </div>
      </div>
    </section>;
}